import styled from 'styled-components';
import { useLayoutContext } from '../../LayoutContext';
import { getRenderSidebarCollapsed } from '../animationCore';
import { NavBar } from './Navbar';
import SidebarModeControlButton from './SidebarModeControlButton';

const Container = styled.div`
  align-self: stretch;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const StyledNav = styled.nav`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

// Warning: changing the internal spacing of the elements of this component
// directly affects the sidebar animation
// e.g. changing the left or right padding/margin values
export function Main() {
  const {
    sidebarCollapsed,
    toggleSidebarMode,
    allowExpandedSidebar,
    sidebarTransitionEnded,
  } = useLayoutContext();
  const renderSidebarCollapsed = getRenderSidebarCollapsed(
    sidebarCollapsed,
    sidebarTransitionEnded,
  );

  return (
    <Container>
      <StyledNav>
        <NavBar />
      </StyledNav>
      {allowExpandedSidebar && (
        <SidebarModeControlButton
          collapsed={renderSidebarCollapsed}
          onClick={toggleSidebarMode}
        />
      )}
    </Container>
  );
}
